import { render, staticRenderFns } from "./SchoolAccessRecord.vue?vue&type=template&id=61d3fe63&scoped=true&"
import script from "./SchoolAccessRecord.vue?vue&type=script&lang=js&"
export * from "./SchoolAccessRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d3fe63",
  null
  
)

export default component.exports